// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/elt-types-and-frequencies.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/elt-types-and-frequencies/elt-types-and-frequencies.js';

mount([g0]);
